export enum ExpertType {
	None = 0,
	Internal = 229380000,
	External = 229380001,
}
